import { useRemoteUserTrack } from "agora-rtc-react";

import { RemoteUser } from "./useAgoraRemoteUsers";

export const useAgoraRemoteTracks = (args: {
  remoteUser: RemoteUser;
}): { audioTrack: MediaStreamTrack | undefined; videoTrack: MediaStreamTrack | undefined } => {
  const { remoteUser } = args;
  const { track: audioTrack } = useRemoteUserTrack(remoteUser, "audio");
  const { track: videoTrack } = useRemoteUserTrack(remoteUser, "video");

  return {
    audioTrack: audioTrack?.getMediaStreamTrack(),
    videoTrack: videoTrack?.getMediaStreamTrack(),
  };
};
